/**
 * bh-optional-remove.js — an open optional block (photo, instructions) is removed by tapping its
 * header, which shows a bin. Empty: it just closes. Has a photo or text: "Remove this?" first
 * (snippets/bh-optional-remove-sheet.liquid), then it is cleared and closed.
 *
 * Why: collapsing used to keep the content while the icon said ×, so people thought they had
 * removed a photo that was still going on the order (2026-10-11). Now closed = nothing in it.
 *
 * Markup-driven: any <details data-bh-remove="kind" data-bh-remove-title data-bh-remove-body>.
 * Runs in the capture phase on the <details>, so it decides before bh-collapse.js's summary
 * handler; to actually close, it lets a click through (`__bhRemoving`) so the close animates.
 * After clearing it fires `bh:optional-removed` on the <details> (detail.kind) so features can
 * drop state tied to the content: bh-print-toggle.js unticks the print, and resets
 * "I'll leave instructions" when the notes go.
 */
(function () {
  const sheet = () => document.getElementById('BhOptionalRemoveSheet');

  function hasContent(d) {
    if ([...d.querySelectorAll('input[type="file"]')].some((i) => i.files && i.files.length)) return true;
    return [...d.querySelectorAll('textarea, input[type="text"]')].some((i) => i.value.trim());
  }

  function clear(d) {
    // The upload's own ✕ resets its preview and drop zone too, not just the input.
    d.querySelectorAll('[data-bh-clear]').forEach((b) => b.click());
    d.querySelectorAll('textarea, input[type="text"]').forEach((i) => {
      i.value = '';
      i.dispatchEvent(new Event('input', { bubbles: true })); // char counter, add-on check
    });
    d.dispatchEvent(new CustomEvent('bh:optional-removed', { bubbles: true, detail: { kind: d.dataset.bhRemove } }));
  }

  function close(d) {
    d.__bhRemoving = true;
    d.querySelector(':scope > summary').click();
    d.__bhRemoving = false;
  }

  function confirm(d) {
    const s = sheet();
    if (!s) { clear(d); close(d); return; }
    s.querySelector('[data-bh-remove-title]').textContent = d.dataset.bhRemoveTitle;
    s.querySelector('[data-bh-remove-body]').textContent = d.dataset.bhRemoveBody;
    s.querySelector('[data-bh-remove-yes]').onclick = () => {
      s.__bhClose ? s.__bhClose() : s.close();
      clear(d);
      close(d);
    };
    s.__bhOpen ? s.__bhOpen(d.querySelector(':scope > summary')) : s.showModal();
  }

  function wire(d) {
    if (d.__bhRemoveWired) return;
    d.__bhRemoveWired = true;
    d.addEventListener('click', (e) => {
      const summary = d.querySelector(':scope > summary');
      if (!d.open || d.__bhRemoving || !summary || !summary.contains(e.target)) return;
      if (!hasContent(d)) { clear(d); return; } // nothing to lose: close as usual
      e.preventDefault();
      e.stopPropagation(); // keep bh-collapse.js from closing it
      confirm(d);
    }, true);
  }

  const init = () => document.querySelectorAll('details[data-bh-remove]').forEach(wire);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
